export const selectAllAdobeData = (state) => state?.adobe?.data
export const selectAdobeStatus = (state) => state?.adobe?.status

export const selectAdobeLinkName = (state) => state.adobe?.data?.link?.linkName
